import { FaCameraRetro, FaUsers, FaShieldAlt, FaGlobe } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaCameraRetro />, // CCTV Camera Icon
        title: 'CCTV Installations',
        count: '2000',
    },
    {
        id: 2,
        icon: <FaUsers />, // Users Icon for Customers Protected
        title: 'Customers Protected',
        count: '3000',
    },
    {
        id: 3,
        icon: <FaShieldAlt />, // Security Shield Icon
        title: 'Security Systems',
        count: '800',
    },
    {
        id: 4,
        icon: <FaGlobe />, // Globe Icon for Global Reach
        title: 'Global Reach',
        count: '25',
    },
];

export default counter;